import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player-pause.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/player.svg';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import MdmProgressBar from '~/components/atoms/Global/MdmProgressBar.vue';
import MdmProgressCircle from '~/components/atoms/Global/MdmProgressCircle.vue';
export default {
  name: 'HomeCarousel',
  components: {
    MdmProgressBar,
    MdmProgressCircle,
    TitleSection,
    SubtitleSection,
    SimpleParagraph
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      color: '#c4a181',
      currentPage: 0,
      show: true,
      progress: 0,
      currentInterval: null,
      hoverState: false,
      mobile: false
    };
  },

  computed: {
    currentPayload() {
      return {
        items: this.payload.items.map((item, i) => ({
          image: {
            small: "\n            ".concat(formatPrismicImage(item.image.small.url, [['w_375', 'c_fill', 'ar_1:1']]), " 375w,\n            ").concat(formatPrismicImage(item.image.small.url, [['w_375', 'dpr_2', 'c_fill', 'ar_1:1']]), " 750w\n            "),
            lqipSmall: i < 1 ? "".concat(formatPrismicImage(item.image.small.url, [['w_375', 'c_fill', 'ar_1:1']], 'q_20,f_auto,e_blur:500'), " 375w") : EMPTY_PIXEL,
            large: "\n            ".concat(formatPrismicImage(item.image.large.url, [['w_1440', 'ar_16:9', 'c_fill']]), " 1440w,\n            ").concat(formatPrismicImage(item.image.large.url, [['w_1440', 'ar_16:9', 'c_fill'], 'dpr_1.5']), " 2160w,\n            ").concat(formatPrismicImage(item.image.large.url, [['w_1440', 'ar_16:9', 'c_fill'], 'dpr_2']), " 2880w\n            "),
            lqipLarge: i < 1 ? "".concat(formatPrismicImage(item.image.large.url, [['w_400', 'ar_16:9', 'c_fill']], 'q_20,f_auto,e_blur:500'), " 1440w") : EMPTY_PIXEL
          },
          title: {
            text: item.title[0] || {},
            color: item.title_color || ''
          },
          subtitle: {
            text: item.subtitle[0] || {},
            color: item.subtitle_color || ''
          },
          simpleParagraph: item.simple_paragraph || [],
          time: item.time || '',
          btnText: item.button || '',
          bgColor: item.background_color || 'hsla(29,36%,64%, 1)',
          bgImage: {
            url: Object.keys(item.background_image).length ? formatPrismicImage(item.background_image, e => e.url) : EMPTY_PIXEL
          },
          color: item.color || 'hsla(29,36%,64%, 1)',
          link: item.link.url || '',
          video_mp4: this.videoFormatted(item.video_mp4.url),
          video_webm: this.videoFormatted(item.video_webm.url),
          tracking: {
            data: {
              event_category: item.event_category || '',
              event_action: item.event_action || '',
              event_label: item.event_label || ''
            }
          }
        }))
      };
    },

    colorBtn() {
      if (this.hoverState) {
        return {
          color: this.currentPayload.items[this.currentPage].color,
          backgroundColor: '#fff',
          borderColor: this.currentPayload.items[this.currentPage].color
        };
      }

      return {
        color: '#fff',
        backgroundColor: this.currentPayload.items[this.currentPage].color,
        borderColor: this.currentPayload.items[this.currentPage].color
      };
    }

  },

  mounted() {
    this.mobile = this.isMobile();
    this.currentPage = this.$refs.carousel.currentPage;
    this.loading();
  },

  methods: {
    changePage(page) {
      this.$refs.carousel.goToPage(page - 1);
      this.currentPage = page - 1;
    },

    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.rerender();
      this.loading();
    },

    rerender() {
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    loading() {
      var $time = this.currentPayload.items[this.currentPage].time || 4;
      var $loading = $time * 1000 / 5 / ($time * 1000) * 100;

      if (this.currentInterval) {
        this.progress = 0;
        clearInterval(this.currentInterval);
        this.currentInterval = null;
      }

      this.currentInterval = setInterval(() => {
        if (this.progress >= 100) {
          this.$refs.carousel.goToPage(this.currentPage === this.currentPayload.items.length - 1 ? 0 : this.currentPage + 1);
          this.currentPage = this.currentPage === this.currentPayload.items.length - 1 ? 0 : this.currentPage + 1;
          clearInterval(this.currentInterval);
        } else {
          this.progress += $loading;
        }
      }, $time * 1000 / 5);
    },

    togglePlay() {
      if (this.currentInterval) {
        clearInterval(this.currentInterval);
        this.currentInterval = null;
      } else {
        this.loading();
      }
    },

    updateBtnHover(isHover) {
      this.hoverState = isHover;
    },

    videoFormatted(url) {
      return url ? formatPrismicImage(url, [['w_375', 'c_fill', 'ar_16:9']], '', 'video') : '';
    }

  }
};